import React from "react";

const Body = () => {
  return (
    <main style={styles.body}>
      {/* 1. КАРТКА JOHN DOE (існуюча) */}
      <div style={styles.card}>
        <img src={"/photo_Serhii.png"} alt="Яворницький Сергій" style={styles.photo} />
        <div style={styles.textContainer}>
          <h2 style={styles.name}>Яворницький Сергій</h2>
          <p style={styles.position}>Junior Developer</p>
        </div>
          </div>
          <div style={styles.card}>
              <img src={"/Syvous_A.jpg"} alt="Artem SYVOUS" style={styles.photo} />
              <div style={styles.textContainer}>
                  <h2 style={styles.name}>Artem SUVOUS</h2>
                  <p style={styles.position}>Software engineer</p>
              </div>
          </div>

            <div style={styles.card}>
                <img src={"/anastasiia_syvvyk.png"} alt="Syvyk Anastasiia" style={styles.photo} />
                <div style={styles.textContainer}>
                  <h2 style={styles.name}>Syvyk Anastasiia</h2>
                    <p style={styles.position}>Project manager</p>
                </div>
            </div>
      {/* 2. КАРТКА ВАШЕ ІМ'Я (додана) */}
      <div style={styles.card}>
        {/*
          УВАГА: Замініть my-photo.png на назву вашого файлу
          та переконайтеся, що файл розміщено у папці public.
        */}
        <img src={"/fel.png"} alt="Фель Богдан" style={styles.photo} />
        <div style={styles.textContainer}>
          <h2 style={styles.name}>Фель Богдан</h2>
          <p style={styles.position}>Junior Developer</p>
        </div>
      </div>
      
    </main>
  );
};

const styles = {
  body: {
    display: "flex",
    flexWrap: "wrap",
  },
  card: {
    width: "150px",
    padding: "1em",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    margin: "1em",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  photo: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  textContainer: {
    marginTop: "0.5em",
  },
  name: {
    fontSize: "1em",
    fontWeight: "bold",
    color: "#333",
    margin: "0",
  },
  position: {
    fontSize: "0.9em",
    color: "#6a0dad", // Same purple color as header
    margin: "0.5em 0 0 0",
  },
}; 

export default Body;
